import { Button } from "PFComponents/button";
import ButtonGroup from "PFComponents/button_group/button_group";
import { LoadingDots } from "PFComponents/loading_dots";
import useAddShortlist from "PFCore/hooks/use_add_shortlist";
import React from "react";
import { useTranslation } from "react-i18next";

import { useMatchCardContext } from "../../match_card_context";

export const MatchCardShortlistButton = () => {
  const { profile, role, shortlists } = useMatchCardContext();
  const { shortlistProfile, undoShortlist, loading, isShortlisted, isShortlistsLoaded, shortlistItem } =
    useAddShortlist(profile, role, shortlists);

  const { t } = useTranslation("activities");

  if (!isShortlistsLoaded) {
    return <LoadingDots />;
  }

  // todo: [PROF-2224] replace with new design once read
  return (
    <div>
      {isShortlisted ? (
        <ButtonGroup style={{ display: "flex" }}>
          <Button text={t("show.matches.shortlisted")} disabled kind="tertiary" style={{ minWidth: 100 }} />
          <Button
            text={t("show.matches.undo")}
            disabled={loading || shortlistItem?.state !== "pending"}
            onClick={() => undoShortlist()}
          />
        </ButtonGroup>
      ) : (
        <Button
          icon="add"
          text={t("show.matches.shortlist")}
          disabled={loading}
          kind="secondary"
          onClick={() => shortlistProfile()}
          style={{ minWidth: 100 }}
        />
      )}
    </div>
  );
};
